const invertedMessages = {
  Condition: 'external.rules.condition',
  'Enter values separated by commas or press Enter after each value':
    'external.rules.condition.placeholder',
  'Select an attribute': 'external.rules.condition.selectAttribute',
  'Select a condition': 'external.rules.condition.selectCondition',
  'Close Rule': 'external.rules.condition.closeRule',
};

export default invertedMessages;
